export default __webpack_public_path__ + "static/media/openseaNoFill.d63aaf90.svg";